export interface ICampusBaseInfo {
  unionId: string;
  name: string; // 姓名
  age: string;
  gender?: string; // 性别
  genderName: string;
  birthday: string; // 出生年月
  photoId: string;
  photoUrl?: string; // 头像
  interCode: string; // 区号
  interCodeName: string;
  phone: string; // 电话
  email: string; // 邮箱
  cityId: string;
  cityName: string; // 现居住城市
  identificationType: string; // 证件类型
  identificationNo: string; // 证件号码
}

export const resumeBaseInfoDefault = {
  unionId: '',
  name: '', // 姓名
  age: '',
  gender: '', // 性别
  genderName: '',
  birthday: '', // 出生年月
  photoId: '',
  photoUrl: '', // 头像
  interCode: '', // 区号
  interCodeName: '',
  phone: '', // 电话
  email: '', // 邮箱
  cityId: '',
  cityName: '', // 现居住城市
  identificationType: '', // 证件类型
  identificationNo: '', // 证件号码
};

export interface ICampusEduExperience {
  renderId: number;
  unionId: string;
  schoolCode: string;
  school: string; // 学校
  major: string; // 专业
  majorCode: string;
  degree: string;
  degreeName: string; // 学历
  startDate: number | null; // 开始时间
  endDate: number | null; // 结束时间
  scoreRanking: string; // 成绩排名
  scoreRankingName: string;
  unifiedEntrance: boolean | null | string; // 是否统招
  fullTimeStatus: boolean | null | string; // 是否全日制
  researchDirection: string; // 研究方向
  mentor: string; // 导师
  labLevel: string;
  labLevelName: string;
  laboratory: string; // 实验室
  collegeName: string; // 学院
  studentId?: string; // 学号
}
export const resumeEduExpListDefault = {
  renderId: 0,
  unionId: '',
  schoolCode: '',
  school: '',
  major: '',
  majorCode: '',
  degree: '',
  degreeName: '',
  startDate: null,
  endDate: null,
  scoreRanking: '',
  scoreRankingName: '',
  unifiedEntrance: null,
  fullTimeStatus: null,
  researchDirection: '',
  mentor: '',
  labLevel: '',
  labLevelName: '',
  laboratory: '',
  collegeName: '',
  studentId: '',
};

export interface ICampusWorkExperience {
  renderId: number;
  unionId: string;
  companyId: string;
  companyName: string; // 公司名称
  department?: string; // 部门名称
  position: string; // 职位名称
  workTypeName: string; // 工作类型
  startDate: number | null; // 在职开始时间
  endDate: number | null; // 在职结束时间
  workDescription?: string; // 工作描述
}

export const resumeWorkExpListDefault = {
  renderId: 0,
  unionId: '',
  companyId: '',
  companyName: '',
  department: '',
  position: '',
  workTypeName: '',
  startDate: null,
  endDate: null,
  workDescription: '',
};

export interface ICampusProjectExperience {
  renderId: number;
  unionId: string;
  projectName: string; // 项目名称
  projectPosition: string; // 项目角色
  startDate: number | null; // 开始时间
  endDate: number | null; // 结束时间
  projectUrl?: string; // 项目链接
  projectDescription?: string; // 项目描述
}

export interface ICampusCampusExperience {
  renderId: number;
  unionId: string;
  experienceName: string;
  role: string;
  startDate: number | null;
  endDate: number | null;
  experienceDescription: string;
}

export const resumeProjectExpListDefault = {
  renderId: 0,
  unionId: '',
  projectName: '',
  projectPosition: '',
  startDate: null,
  endDate: null,
  projectUrl: '',
  projectDescription: '',
};

export const resumeCampusExpListDefault = {
  renderId: 0,
  unionId: '',
  experienceName: '',
  role: '',
  startDate: null,
  endDate: null,
  experienceDescription: '',
};

export interface ICampusHonor {
  renderId: number;
  unionId: string;
  honorName: string; // 荣誉名称
  honorDesc: string; // 荣誉描述
}

export const resumeHonorListDefault = {
  renderId: 0,
  unionId: '',
  honorName: '',
  honorDesc: '',
};

export interface ICampusLanguage {
  renderId: number;
  unionId: string;
  language: string;
  languageName: string; // 语言类型
  level: string; // 语言水平
  levelName: string;
  examinationName?: string;
  examinationId?: string;
  score?: string;
}

export const resumeLanguageListDefault = {
  renderId: 0,
  unionId: '',
  language: '',
  languageName: '',
  level: '',
  levelName: '',
  examinationName: '',
  examinationId: '',
  score: '',
};

export interface ICampusCertificate {
  renderId: number;
  unionId: string;
  name: string; // 证书名称
}

export const resumeCertificateListDefault = {
  renderId: 0,
  unionId: '',
  name: '',
};

export interface ICampusSkill {
  renderId: number;
  unionId: string;
  skillCode: string;
  skillName: string; // 技能类型
  skillLevel: string; // 技能水平
  skillLevelName: string;
}

export const resumeSkillListDefault = {
  renderId: 0,
  unionId: '',
  skillCode: '',
  skillName: '',
  skillLevel: '',
  skillLevelName: '',
};

export interface ICampusPaper {
  renderId: number;
  unionId: string;
  thesisName: string; // 论文名称
  thesisLevelCode: string;
  thesisLevelName: string; // 发表渠道
  authorOrderCode: string; // 作者顺序
  influenceFactor?: string; // 影响因子
  thesisUrl?: string; // 论文链接
  authorOrderName: string;
}

export const resumeThesisListDefault = {
  renderId: 0,
  unionId: '',
  thesisName: '',
  thesisLevelCode: '',
  thesisLevelName: '',
  authorOrderCode: '',
  influenceFactor: '',
  thesisUrl: '',
  authorOrderName: '',
};

export interface ICampusCompetition {
  renderId: number;
  unionId: string;
  competitionName: string;
  competitionCode: string; // 获奖大赛名称
  awardName: string;
  awardCode: string;
}

export const resumeCompetitionListDefault = {
  renderId: 0,
  unionId: '',
  competitionName: '',
  competitionCode: '',
  awardName: '',
  awardCode: '',
};

export interface ICampusWorksAttachmentList {
  renderId: number;
  unionId: string;
  fileId: string;
  name: string;
  type: string;
  fileTypeCode: string;
}

export const resumeWorksAttachmentListDefault = {
  renderId: 0,
  fileId: '',
  name: '',
  type: '',
};

export interface ICampusResumeAttachmentList {
  renderId: number;
  unionId: string;
  fileId: string;
  name: string;
  type: string;
  fileTypeCode: string;
}

export const resumeAttachmentListDefault = {
  renderId: 0,
  unionId: '',
  fileId: '',
  name: '',
  type: '',
  fileTypeCode: '',
};

export const campusTabItems = [
  {
    key: 'base_info_edit',
    title: '基础信息',
  },
  {
    key: 'edu_experience_edit',
    title: '教育经历',
  },
  {
    key: 'language_standard_edit',
    title: '语言水平',
  },
  {
    key: 'work_experience_edit',
    title: '工作/实习经历',
  },
  {
    key: 'project_experience_edit',
    title: '项目经历',
  },
  {
    key: 'campus_experience_edit',
    title: '校园经历',
  },
  {
    key: 'honor_edit',
    title: '荣誉',
  },
  {
    key: 'certificate_edit',
    title: '证书',
  },
  // {
  //   key: 'skill_standard_edit',
  //   title: '技能水平',
  // },
  {
    key: 'paper_edit',
    title: '论文',
  },
  {
    key: 'competition_edit',
    title: '竞赛',
  },
  {
    key: 'upload_sample_reel_edit',
    title: '作品集',
  },
];

/**
 * 简历解析候选人教育经历
 */
export interface ResumeEducationExperience {
  unionId: string | null;
  school: string;
  schoolCode: string | null;
  major: string;
  majorCode: string | null;
  degree: string | null;
  degreeName: string | null;
  startDate: string | null;
  endDate: string | null;
  scoreRanking: string | null;
  scoreRankingName: string | null;
  unifiedEntrance: string | null;
  researchDirection: string | null;
  labLevel: string | null;
  labLevelName: string | null;
  laboratory: string | null;
  collegeCode: string | null;
  collegeName: string | null;
  mentor: string | null;
}

export interface ResumeSchoolEnum {
  id: string;
  name: string;
  code: string | null;
}
